import React from "react";

class TranslatedStringDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    var ts = this.props.data ? I18n.t(this.props.data) : I18n.t('none')
    return (
      ts
    );
  }

};

export default TranslatedStringDataType